// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"197":"aacdb1cb","443":"3efcb934","565":"d79b16dc","642":"cee88584","839":"2bd5d3d6","968":"9de75db3"}[chunkId] + ".js";
};